import { useEffect, useState } from 'react'
import { X, AlertTriangle } from 'lucide-react'
import { supabase } from '../lib/supabase'
import useLocationReminderStore from '../store/locationReminderStore'
import useAuthStore from '../store/authStore'
import { mapsUrl } from '../utils/addressUtils'

export default function TrafficAlertBanner() {
  const userId = useAuthStore((s) => s.user?.id)
  const alertedReminders = useLocationReminderStore((s) => s.alertedReminders)
  const dismissAlert = useLocationReminderStore((s) => s.dismissAlert)
  const [currentAlert, setCurrentAlert] = useState(null)
  const [reminders, setReminders] = useState({})

  // Subscribe to location_reminders changes (only 'alerted' status)
  useEffect(() => {
    if (!userId) return

    const channel = supabase
      .channel(`location-reminders-${userId}`)
      .on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: 'location_reminders',
        filter: `user_id=eq.${userId}`,
      }, ({ new: row }) => {
        if (row.status === 'alerted' && !currentAlert) {
          const reminder = {
            id: row.id,
            destination: row.destination_address,
            travelTime: row.last_travel_time_seconds
              ? `${Math.ceil(row.last_travel_time_seconds / 60)} min`
              : 'N/A',
          }
          setCurrentAlert(reminder)
          setReminders((prev) => ({ ...prev, [row.id]: row }))
        }
      })
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [userId, currentAlert])

  const handleDismiss = () => {
    if (currentAlert) {
      dismissAlert(currentAlert.id)
      setCurrentAlert(null)
    }
  }

  if (!currentAlert) return null

  return (
    <div
      style={{
        backgroundColor: '#FEF08A',
        borderBottom: '2px solid #FBBF24',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div style={{ display: 'flex', gap: 10, flex: 1, alignItems: 'flex-start' }}>
        <AlertTriangle size={20} style={{ color: '#D97706', flexShrink: 0, marginTop: 2 }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, fontSize: '0.95rem', color: '#000' }}>
            Parti ora!
          </div>
          <div style={{ fontSize: '0.85rem', color: '#333', marginTop: 2 }}>
            {currentAlert.travelTime} per {currentAlert.destination}
          </div>
          {reminders[currentAlert.id] && (
            <a
              href={mapsUrl(currentAlert.destination)}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                marginTop: 6,
                fontSize: '0.8rem',
                color: '#0369A1',
                textDecoration: 'underline',
              }}
            >
              Apri mappe →
            </a>
          )}
        </div>
      </div>
      <button
        onClick={handleDismiss}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <X size={18} style={{ color: '#666' }} />
      </button>
    </div>
  )
}
